import { useMutation, useQueryClient } from "@tanstack/react-query";

import {
	type CreateDocumentRequest,
	postDocuments,
} from "Infrastructure/Api/Api";
import { processResponse } from "Infrastructure/Api/ApiUtils";

export const useCreateDocumentMutation = () => {
	const queryClient = useQueryClient();
	return useMutation({
		mutationFn: processResponse((document: CreateDocumentRequest) =>
			postDocuments(document),
		),
		onSuccess: () => {
			queryClient.invalidateQueries({ queryKey: ["documents"] });
			queryClient.invalidateQueries({ queryKey: ["contracts"] });
		},
	});
};
